export const checkVarEnvironment = (environment: string) => {
    if (['true', 'false'].includes(environment || '')) {
        return JSON.parse(environment);
    }

    return false;
};

export enum EEnvironment {
    REACT_APP_WEBVIEW_POSTSALES_ENABLED = 'REACT_APP_WEBVIEW_POSTSALES_ENABLED',
    REACT_APP_WEBVIEW_DEVICES_ENABLED = 'REACT_APP_WEBVIEW_DEVICES_ENABLED',
    REACT_APP_WEBVIEW_O2TELEVISION_EXPLORE_ENABLED = 'REACT_APP_WEBVIEW_O2TELEVISION_EXPLORE_ENABLED',
    REACT_APP_WEBVIEW_O2CLOUD_EXPLORE_ENABLED = 'REACT_APP_WEBVIEW_O2CLOUD_EXPLORE_ENABLED',
    REACT_APP_WEBVIEW_PROFILE_OBD_ENABLED = 'REACT_APP_WEBVIEW_PROFILE_OBD_ENABLED',
    REACT_APP_WEBVIEW_BLUETV_CONVERGENT_ENABLED = 'REACT_APP_WEBVIEW_BLUETV_CONVERGENT_ENABLED',
    REACT_APP_WEBVIEW_BLUEADDLINE_CONVERGENT_ENABLED = 'REACT_APP_WEBVIEW_BLUEADDLINE_CONVERGENT_ENABLED',
    REACT_APP_WEBVIEW_TV_CONVERGENT_ENABLED = 'REACT_APP_WEBVIEW_TV_CONVERGENT_ENABLED',
    REACT_APP_WEBVIEW_DEVICES_CONVERGENT_ENABLED = 'REACT_APP_WEBVIEW_DEVICES_CONVERGENT_ENABLED',
    REACT_APP_WEBVIEW_O2CLOUD_CONVERGENT_ENABLED = 'REACT_APP_WEBVIEW_O2CLOUD_CONVERGENT_ENABLED',
    REACT_APP_WEBVIEW_RATES_CONVERGENT_ENABLED = 'REACT_APP_WEBVIEW_RATES_CONVERGENT_ENABLED',
    REACT_APP_WEBVIEW_ADDLINE_CONVERGENT_ENABLED = 'REACT_APP_WEBVIEW_ADDLINE_CONVERGENT_ENABLED',
    REACT_APP_WEBVIEW_BLUETV_MOBILE_ENABLED = 'REACT_APP_WEBVIEW_BLUETV_MOBILE_ENABLED',
    REACT_APP_WEBVIEW_BLUEGOCONVERGENT_MOBILE_ENABLED = 'REACT_APP_WEBVIEW_BLUEGOCONVERGENT_MOBILE_ENABLED',
    REACT_APP_WEBVIEW_TV_MOBILE_ENABLED = 'REACT_APP_WEBVIEW_TV_MOBILE_ENABLED',
    REACT_APP_WEBVIEW_DEVICES_MOBILE_ENABLED = 'REACT_APP_WEBVIEW_DEVICES_MOBILE_ENABLED',
    REACT_APP_WEBVIEW_O2CLOUD_MOBILE_ENABLED = 'REACT_APP_WEBVIEW_O2CLOUD_MOBILE_ENABLED',
    REACT_APP_WEBVIEW_RATES_MOBILE_ENABLED = 'REACT_APP_WEBVIEW_RATES_MOBILE_ENABLED',
    REACT_APP_WEBVIEW_ADDLINE_MOBILE_ENABLED = 'REACT_APP_WEBVIEW_ADDLINE_MOBILE_ENABLED',
    REACT_APP_WEBVIEW_BLUETV_FIBER_ENABLED = 'REACT_APP_WEBVIEW_BLUETV_FIBER_ENABLED',
    REACT_APP_WEBVIEW_BLUEGOCONVERGENT_FIBER_ENABLED = 'REACT_APP_WEBVIEW_BLUEGOCONVERGENT_FIBER_ENABLED',
    REACT_APP_WEBVIEW_TV_FIBER_ENABLED = 'REACT_APP_WEBVIEW_TV_FIBER_ENABLED',
    REACT_APP_WEBVIEW_DEVICES_FIBER_ENABLED = 'REACT_APP_WEBVIEW_DEVICES_FIBER_ENABLED',
    REACT_APP_WEBVIEW_O2CLOUD_FIBER_ENABLED = 'REACT_APP_WEBVIEW_O2CLOUD_FIBER_ENABLED',
    REACT_APP_WEBVIEW_RATES_FIBER_ENABLED = 'REACT_APP_WEBVIEW_RATES_FIBER_ENABLED',
    REACT_APP_WEBVIEW_ADDLINE_FIBER_ENABLED = 'REACT_APP_WEBVIEW_ADDLINE_FIBER_ENABLED',
    REACT_APP_STOPPER_LOGIN_DISABLED = 'REACT_APP_STOPPER_LOGIN_DISABLED',
    REACT_APP_STOPPER_LOGIN_MC_DISABLED = 'REACT_APP_STOPPER_LOGIN_MC_DISABLED',
    REACT_APP_STOPPER_HOME_DISABLED = 'REACT_APP_STOPPER_HOME_DISABLED',
    REACT_APP_STOPPER_CONSUMPTIONS_DISABLED = 'REACT_APP_STOPPER_CONSUMPTIONS_DISABLED',
    REACT_APP_STOPPER_BILLS_DISABLED = 'REACT_APP_STOPPER_BILLS_DISABLED',
    REACT_APP_STOPPER_BILL_PAYMENT_DISABLED = 'REACT_APP_STOPPER_BILL_PAYMENT_DISABLED',
    REACT_APP_STOPPER_PROFILE_ORDERS_DISABLED = 'REACT_APP_STOPPER_PROFILE_ORDERS_DISABLED',
    REACT_APP_STOPPER_PROFILE_CUSTOMER_DATA_DISABLED = 'REACT_APP_STOPPER_PROFILE_CUSTOMER_DATA_DISABLED',
    REACT_APP_STOPPER_PROFILE_NOTIFICATIONS_DISABLED = 'REACT_APP_STOPPER_PROFILE_NOTIFICATIONS_DISABLED',
    REACT_APP_STOPPER_PROBLEMS_DISABLED = 'REACT_APP_STOPPER_PROBLEMS_DISABLED',
    REACT_APP_WEBVIEW_O2CLOUD_HOME_ENABLED = 'REACT_APP_WEBVIEW_O2CLOUD_HOME_ENABLED',
    REACT_APP_WEBVIEW_CARDS_PRECLIENT_ENABLED = 'REACT_APP_WEBVIEW_CARDS_PRECLIENT_ENABLED',
    REACT_APP_WEBVIEW_BLUEDEVICES_CONVERGENT_ENABLED = 'REACT_APP_WEBVIEW_BLUEDEVICES_CONVERGENT_ENABLED',
    REACT_APP_WEBVIEW_BLUEDEVICES_MOBILE_ENABLED = 'REACT_APP_WEBVIEW_BLUEDEVICES_MOBILE_ENABLED',
    REACT_APP_WEBVIEW_BLUEDEVICES_FIBER_ENABLED = 'REACT_APP_WEBVIEW_BLUEDEVICES_FIBER_ENABLED',
    REACT_APP_WEBVIEW_DUPLICATE_ESIM_ENABLED = 'REACT_APP_WEBVIEW_DUPLICATE_ESIM_ENABLED',
    REACT_APP_WEBVIEW_MULTISIM_ENABLED = 'REACT_APP_WEBVIEW_MULTISIM_ENABLED',
}

type IEnvironment = {
    [key in EEnvironment]: boolean;
};

export const managementEnvironment: any = (): IEnvironment => {
    const environments = { ...process.env };
    return Object.entries(environments).reduce((acc, cur) => {
        const [key, value] = cur;

        return { ...acc, [key]: checkVarEnvironment(value!) };
    }, {}) as IEnvironment;
};
